import { useState } from "react";
import { PrivateTransferReviewModal } from "./PrivateTransferReviewModal";
import { PublicTransferReviewModal } from "./PublicTransferReviewModal";
import { VerifiedIdModal } from "./VerifiedIdModal";
import type { TransferFormData } from "./transfersConfig";

export function TransfersReviewModal({
  isOpen,
  onClose,
  transferFormData,
  onTransfer,
}: {
  isOpen: boolean;
  onClose: () => void;
  transferFormData: TransferFormData | null;
  onTransfer: () => void;
}) {
  if (!isOpen || !transferFormData) {
    return null;
  }

  if (transferFormData.transferMode === "private") {
    return (
      <PrivateTransferFlow
        onClose={() => {
          onClose();
        }}
        transferFormData={transferFormData}
        onTransfer={onTransfer}
      />
    );
  }

  return (
    <PublicTransferReviewModal
      isOpen={isOpen}
      onClose={onClose}
      transferFormData={transferFormData}
      onTransfer={onTransfer}
    />
  );
}

function PrivateTransferFlow({
  onClose,
  transferFormData,
  onTransfer,
}: {
  onClose: () => void;
  transferFormData: TransferFormData;
  onTransfer: () => void;
}) {
  const [state, setState] = useState<"verified-id" | "review">("verified-id");

  function onVerified() {
    setState("review");
  }

  function onBack() {
    setState("verified-id");
  }

  if (state === "verified-id") {
    return <VerifiedIdModal onClose={onClose} onVerified={onVerified} />;
  }

  return (
    <PrivateTransferReviewModal
      onClose={onClose}
      transferFormData={transferFormData}
      onTransfer={onTransfer}
      onBack={onBack}
    />
  );
}
